<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="schools-posts-area" >
        <div class="row">
          <div class="col-lg-3 schools-posts-area-lf" style="padding-right: 0;">
              <div class="schools-posts-area-lf-t">Schools</div>
              <ul class="schools-posts-area-lf-m">
                    <li @click="checkLi('1')" :class="[currentBlog.id==='1'?'active':'']">Sino-French Institute</li>
                    <li @click="checkLi('2')" :class="[currentBlog.id==='2'?'active':'']">School of Smart Governance</li>
                    <li @click="checkLi('3')" :class="[currentBlog.id==='3'?'active':'']">Silk Road School</li>
                    <li @click="checkLi('4')" :class="[currentBlog.id==='4'?'active':'']">International College</li>
              </ul>
            <img class="schools-posts-area-lf-b" src="http://en.sc.ruc.edu.cn/static/images/school/png10.png" />
          </div>
          <div class="col-lg-9 post-list blog-post-list">
            <div class="single-post">



                <h2 class="blog-detail-tit">
                  {{ currentBlog.title }}
                </h2>




              <div class="blog-detail-content content-wrap  wow slideInRight">
                <img class="blog-detail-content-img wow slideInLeft" :src="currentBlog.img" alt="" >
                <p v-html="currentBlog.content">
                </p>
              </div>

            </div>
            <div class="showLink" v-if="currentBlog.link">
              <span>link: </span><a :href="currentBlog.link" class="blog-detail-more">Silk Road School</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        currentBlog: {},
        blogList: [
          {
            id: '1',
            title: 'Sino-French Institute',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/3.jpg',
            link: '',
            author: '中法学院',
            content: 'Inaugurated in June 2012, Sino-French Institute is the first Chinese-foreign cooperative educational institution focusing on humanities and social sciences in China founded by Renmin University of China in cooperation with Sorbonne University, Paul-Valéry Montpellier 3 University, and KEDGE Business School. The institute is affiliated with research institutes such as the Institut de Recherche Interdisciplinaire sur la France et la Francophonie, which promotes people-to-people exchanges between China and French-speaking countries through country studies and comparative studies, research on Sino-French cooperative undertakings, as well as research on health management and aging issues.'
          }, {
            id: '2',
            title: 'School of Smart Governance',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/4.JPG',
            link: '',
            author: '智慧治理学院',
            content: 'School of Smart Governance was established in September 2023. Guided by the theory of intelligent governance, it focuses on the frontiers of the times. It has four visions, including “world-oriented training of basic talents”, “future-oriented research and development of governance technology”, “society-oriented governance and innovative design”, and “development-oriented governance consultation”. The institute aims to cultivate cross-composite high-end talents with solid knowledge of data science, basic theory of artificial intelligence and specialized knowledge in humanities and social sciences, excellent data analysis, artificial intelligence algorithm design and intelligent governance, as well as the ability to solve practical problems in governance.'
          }, {
            id: '3',
            title: 'Silk Road School',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/5.jpg',
            link: 'http://srs.ruc.edu.cn/English/index.htm',
            author: '丝路学院',
            content: 'Silk Road School was inaugurated in May 2018, and is the first school to be named with “Silk Road” among the “Double First-Class” universities in China. It integrates world-class educational resources, creates a curriculum system of China’s national conditions around the four directions, namely China’s politics, economy, law and culture. Besides, it gathers global political leaders, business elites and outstanding scholars to cultivate internationalized and composite high-end talents and future elite leaders who love China and have a deep understanding of China’s development path, model and experience for the countries and regions along the “Belt and Road”, and to contribute to the promotion of exchanges and mutual understanding of civilizations and the building of a community with a shared future for mankind.'
          }, {
            id: '4',
            title: 'International College',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/6.jpg',
            link: '',
            author: '国际学院',
            content: 'International College (Suzhou Research Institute) was inaugurated in September 2007. On September 6, 2009, the opening ceremony of the first full-time students was held. It is an important career for Renmin University of China to carry out teaching, training, cooperative research, team building, logistic support and other related activities in Suzhou, with a focus on postgraduate training.'
          }
        ]
      }
    },
    watch: { // 监听，当路由发生变化的时候执行
      $route (to, from) {
        if (to) {
          const id = this.$route.query.id
          if (id) {
            this.$nextTick(() => {
              this.currentBlog = this.getId(id)
            })
          }
        }
      }
    },
    created () {
      const id = this.$route.query.id
      this.currentBlog = this.getId(id)
    },
    methods: {
      getId (id) {
        return this.blogList.find(item => item.id === id)
      },
      checkLi (id) {
        this.currentBlog = this.getId(id)
      }
    }
  }
</script>

<style scoped lang="scss">
.blog-detail-tit:before{
  content: ' ';
  background-image: url(http://en.sc.ruc.edu.cn/static/images/titBg.png);

}

.blog-detail-content{
  width: 90%;
  margin: 40px auto 10px auto;
  display: flex;
  .blog-detail-content-img{
    width: 35%;
    margin: 10px 20px 5px 0px;
    flex-shrink: 0;
    height: fit-content;
  }
    p{
      flex: 1;
      font-weight: 400;
      font-size: 17px;
      line-height: 1.6;
      color: #666666;
    }
}
.showLink{
    float: right;
    padding: 20px ;
   //border-bottom: 1px solid #409eff;
}

@media (max-width: 575.98px) {
  .blog-detail-content {
    display: block !important;
    width: 90%;
    margin: 10px auto 10px auto;

    .blog-detail-content-img {
      width: 100%;
      margin: 8px 10px 0px 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SchoolDetails.vue?7a35384f